module.exports = __webpack_public_path__ + "static/media/greenChecked.5b7e9e16.svg";